import { Api } from './Api'

const petsPathTo = {
  save: (data) => {
    return Api.request({
      url: '/pets.json',
      method: 'post',
      data: data
    })
  },
  list: (params = {}) => {
    return Api.request({
      url: '/pets.json',
      method: 'get',
      params
    })
  },
  update: (id, data) => {
    return Api.request({
      url: '/pets/' + id + '.json',
      method: 'put',
      data: {
        pet: data
      }
    })
  },
  delete: (id) => {
    return Api.request({
      url: '/pets/' + id + '.json',
      method: 'delete'
    })
  },
  update_avatar: (id, data) => {
    return Api.request({
      url: '/pets/' + id + '/update_avatar.json',
      method: 'put',
      data: {
        pet: data
      }
    })
  }
}


export default petsPathTo
